<template>
  <div v-wechat-title="titleTop">
    <div class="allBack" />
    <TopBar :pagetitle="title" :back-url="backurl" />
    <div class="sea">
      <div class="topLogo">
        <img src="/dive/topRateLogo.png">
      </div>
      <span class="wave" />
      <span class="wave" />
      <span class="wave" />
    </div>
    <van-skeleton :row="30" :loading="loading" style="padding:1em;">
      <div v-if="data" class="buttonRect">
        <div v-for="item in data" :key="item.type" class="button" :style="item.select?'color:'+GetDiveMainBack():''" @click="onTab(item)">
          {{ GetEnumText("Em_DiveTopType",item.type) }}
        </div>
      </div>
      <div class="listRect">
        <div v-for="item in rateList" :key="item.userId" class="line" @click="onSelectItem(item.userId)">
          <van-row>
            <van-col span="4" class="rank">
              <img v-if="item.rank<=3" :src="'/dive/topRate_'+item.rank+'.png'" style="vertical-align: middle;">
              <span v-if="item.rank>3">{{ item.rank }}</span>
            </van-col>
            <van-col span="13" class="name"><van-image style="vertical-align: middle;margin-right:0.5em" round width="1.4em" height="1.4em" lazy-load :src="item.icon" />{{ item.name }}</van-col>
            <van-col span="7" class="value rigth"><span v-if="selectType !== 'COACH'">{{ item.value }}</span></van-col>
          </van-row>
        </div>
      </div>
    </van-skeleton>
  </div>
</template>
<script>
import request from '@/utils/request'
import { Button, Image, Lazyload, Skeleton } from 'vant'
import TopBar from '@/components/TopBar'
import { MyNotify, ShowMoney, GetEnumText, formatDate } from '@/utils/base'
import { GetDiveMainBack, GetColorMain, GetColorSecondary, GetDiveTitle, GetColorMainLine } from '@/utils/base'
export default {
  components: {
    [Button.name]: Button,
    [Image.name]: Image,
    [Lazyload.name]: Lazyload,
    [Skeleton.name]: Skeleton,
    TopBar
  },
  data() {
    return {
      titleTop: '',
      title: '风云榜',
      backurl: '/dive',
      data: undefined,
      loading: true,
      rateList: [],
      selectType: undefined
    }
  },

  created() {
    this.titleTop = GetDiveTitle()
    this.init()
  },
  methods: {
    MyNotify,
    ShowMoney,
    GetColorMainLine,
    GetDiveMainBack,
    GetColorMain,
    GetColorSecondary,
    GetDiveTitle,
    GetEnumText,
    formatDate,
    init() {
      request({
        url: '/Dive/getDiveTopList',
        method: 'post'
      }).then(response => {
        this.loading = false
        if (!response.success) {
          return
        }
        this.data = response.data
        this.selectList()
      })
    },
    selectList() {
      var select = this.data.filter(m => m.type === this.selectType)
      // console.log('select', select)
      if (select.length > 0) {
        this.rateList = JSON.parse(JSON.stringify(select[0].list))
      } else {
        this.selectType = this.data[0].type
        this.rateList = JSON.parse(JSON.stringify(this.data[0].list))
      }
      this.data.forEach(item => {
        if (item.type === this.selectType) {
          item.select = true
        } else {
          item.select = false
        }
      })
    },
    onTab(item) {
      this.selectType = item.type
      this.selectList()
    },
    onSelectItem(userId) {
      if (this.selectType === 'COACH') {
        this.$router.push('/pro/coachHome/' + userId)
      } else {
        MyNotify('info', '暂未开放')
      }
    }
  }
}
</script>
<style scoped>
.allBack{
  position: fixed;
  width: 100vw;
  height: 100vh;
  left: 0;
  top:0;
  background-color: #fff;
  z-index: -1;
}
.sea {
	width:100vw;
	height: calc(40vw);
	background-color:#06A7FE;
	/* background-image:linear-gradient(
        darkblue,rgba(255,255,255,0) 80%,rgba(255,255,255,0.5)); */
	position: relative;
	overflow:hidden;
}
.sea .topLogo{
  position: absolute;
  text-align: center;
  height: calc(40vw - 4em);
  text-align: center;
  left: 0;
  right: 0;
  top:2em;
  z-index: 10;
}
.sea .topLogo img{
  height: 100%;
}
.sea .wave {
	position:absolute;
	top:40vw;
	left:-200vw;
	width:500vw;
	height:500vw;
	background:#016CA7;
	border-radius:43%;
	filter:opacity(0.2);
	animation:drift linear infinite;
	transform-origin:50% 49%;
}

.sea .wave:nth-of-type(1) {
	animation-duration:51s;
}
.sea .wave:nth-of-type(2) {
    animation-duration:120s;
    background-color:#06B7FA;
}
.sea .wave:nth-of-type(3) {
	animation-duration:73s;
	background-color:#016CA7;
	filter:opacity(0.1);
}
@keyframes drift {
	from {transform:rotate(360deg);
  }
}

.buttonRect{
  display:flex;
  padding: 1.5em 0;
  background-color: #fff;
  margin-top: 4px;
  font-weight: 700;
  color: #CBCBCB;
  border-bottom: 1px solid #f5f5f5;
}
.buttonRect .button{
  flex: 1;
  text-align: center;
  font-size: 0.9em;
}

.listRect{
  background-color: #fff;
}
.listRect .line{
  padding-bottom: 0.5em;
  margin:0 1em 0.5em 1em;
  border-bottom: 1px solid #f5f5f5;
  line-height: 1.4em;
}
.listRect .line:first-child{
  padding-top: 0.5em;
}
.listRect .rank
{
  text-align: center;
  font-weight: 700;

}
.listRect .rank img{
  height: 1.4em;
}
.listRect .name
{
  vertical-align: middle;
 font-size: 0.9em;
}
.listRect .value
{
  font-weight: 700;
   font-size: 0.9em;
}
</style>
